import AuthRepository from '../../domain/repositories/AuthRepository';
import AuthDataStoreFactory from '../factories/AuthDataStoreFactory';
import AuthDataStore from '../datastores/AuthDataStore';

export default class AuthDataRepository implements AuthRepository {
  logIn(username: string, password: string) {
    const authDataStore: AuthDataStore = AuthDataStoreFactory.create();
    return authDataStore.logIn(username, password);
  }

  refreshToken(value: string) {
    const authDataStore: AuthDataStore = AuthDataStoreFactory.create();
    return authDataStore.refreshToken(value);
  }

  logOut(value: string) {
    const authDataStore: AuthDataStore = AuthDataStoreFactory.create();
    return authDataStore.logOut(value);
  }
}
